// extracted by mini-css-extract-plugin
export var emptyState = "_6l-d";
export var statCard = "_6l-c";
export var table = "_6l-0";
export var tableCell = "_6l-4";
export var tableCellClickable = "_6l-5 _6l-4";
export var tableCellDefault = "_6l-6 _6l-4";
export var tableCellEmpty = "_6l-8";
export var tableCellWithValue = "_6l-7";
export var tableContainer = "_6l-e";
export var tableHeaderWeight = "_6l-1";
export var tableHeaderZone = "_6l-2";
export var tableRowHeader = "_6l-3";
export var viewModeButton = "_6l-9";
export var viewModeButtonActive = "_6l-a _6l-9";
export var viewModeButtonInactive = "_6l-b _6l-9";